import React from 'react';
import { View, Text } from '@react-pdf/renderer';
import { type, colors, space } from '../theme';
import Chip from './Chip';

// Matches the in-app Risk card. Light gray background, red left rail
// (uniform across all risks regardless of severity — severity is conveyed by
// the chip), description on top, mitigation inline, type + severity chips at
// the BOTTOM.
const SEVERITY_VARIANT = { high: 'danger', medium: 'warning', low: 'success' };

const RiskCard = ({ risk }) => (
  <View wrap={false} style={{
    flexDirection: 'row',
    backgroundColor: '#f5f7fa',
    borderRadius: 4,
    overflow: 'hidden',
    marginBottom: space.sm,
  }}>
    <View style={{ width: 3, backgroundColor: colors.danger }} />
    <View style={{ flex: 1, paddingVertical: 10, paddingHorizontal: space.md }}>
      <Text style={[type.bodyMed, { color: colors.ink }]}>{risk.description}</Text>
      {risk.mitigation && (
        <Text style={[type.body, { color: colors.inkSoft, marginTop: 4 }]}>
          <Text style={{ fontWeight: 600, color: colors.ink }}>Mitigation: </Text>
          {risk.mitigation}
        </Text>
      )}
      {(risk.type || risk.severity) && (
        <View style={{ flexDirection: 'row', flexWrap: 'wrap', gap: 6, marginTop: 6 }}>
          {risk.type && <Chip variant="neutral">{risk.type}</Chip>}
          {risk.severity && (
            <Chip variant={SEVERITY_VARIANT[risk.severity] || 'neutral'}>
              {risk.severity} severity
            </Chip>
          )}
        </View>
      )}
    </View>
  </View>
);

export default RiskCard;
